// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605120805/js/" + chunkId + "." + {"44":"b3b263f6","225":"fcd56bc5","481":"114c8dba","486":"ac60a9fc","770":"d3583154"}[chunkId] + ".0.5712733938044234.chunk.js";
};